<template>
  <div>
    <b-row class="d-flex align-items-center">
      <b-col cols="8">
        <h1 class="font-weight-bolder mb-0">Push Notification Campaigns</h1>
      </b-col>
      <b-col cols="4" class="text-right">
        <b-link :to="{ name: 'marketing-push-notifications-new' }">
          <b-button size="md" variant="primary">
            <feather-icon icon="PlusIcon" />
            <span class="text-lg text-nowrap" style="margin-left: 4px"
              >New Push Notification</span
            >
          </b-button>
        </b-link>
      </b-col>
    </b-row>

    <b-row class="mt-1">
      <b-col cols="12">
        <b-card>
          <b-row>
            <b-col cols="6" md="3">
              <b-form-input
                v-model="searchQuery"
                placeholder="Search Campaigns..."
              />
            </b-col>

            <b-col cols="6" md="3">
              <flat-pickr
                id="startDate"
                v-model="startDate"
                class="form-control"
                :config="configDate"
                placeholder="mm/dd/yyyy"
              />
            </b-col>
            <b-col cols="6" md="3">
              <flat-pickr
                id="endDate"
                v-model="endDate"
                class="form-control"
                :config="configDate"
                placeholder="mm/dd/yyyy"
              />
            </b-col>
            <b-col cols="6" md="3">
              <v-select
                :value="option"
                :options="options"
                :reduce="(val) => val.value"
                :clearable="false"
                @input="(val) => (option = val.value)"
                class="w-100"
              />
            </b-col>
          </b-row>

          <b-table
            :items="items"
            :fields="tableColumns"
            responsive
            show-empty
            primary-key="id"
            thead-class="text-nowrap"
            class="mt-1 table-hover-custom"
            select-mode="single"
            ref="selectableTable"
            selectable
            @row-selected="onRowSelected"
            hover
          >
            <!-- <template #empty>
                <div v-if="list.loading" class="text-center text-dark my-2">
                  <p>Loading... Please wait</p>
                </div>
        
                <div
                  v-else-if="!list.loading && fetchUsers.length === 0"
                  class="text-center text-dark my-2"
                >
                  No matching records found
                </div>
              </template> -->
            <template #cell(title)="{ item }">
              <div class="d-flex align-items-center font-weight-bold id-column">
                <span class="text-nowrap">{{ item.title }}</span>
              </div>
            </template>

            <template #cell(status)="{ item }">
              <b-media vertical-align="center">
                <div
                  class="text-white bg-success d-flex rounded justify-content-center align-items-center font-weight-bolder"
                  style="padding: 2px 4px; width: fit-content"
                >
                  {{ item.status }}
                </div>
              </b-media>
            </template>

            <template #cell(sentDate)="{ item }">
              <b-media vertical-align="center">
                {{ item.sentDate }}
              </b-media>
            </template>

            <template #cell(sentTime)="{ item }">
              <b-media vertical-align="center">
                <div class="d-flex align-items-center">
                  {{ item.sentTime }}
                </div>
              </b-media>
            </template>
            <template #cell(recipients)="{ item }">
              <b-media vertical-align="center">
                <div class="d-flex align-items-center">
                  {{ item.recipients }}
                </div>
              </b-media>
            </template>
            <template #cell(targetGroup)="{ item }">
              <b-media vertical-align="center">
                <div class="d-flex align-items-center">
                  {{ item.targetGroup }}
                </div>
              </b-media>
            </template>
            <template #cell(actions)>
              <b-media vertical-align="center">
                <div class="d-flex align-items-center">
                  <b-button size="sm" variant="outline-secondary" class="mr-1">
                    Edit
                  </b-button>
                  <b-button size="sm" variant="outline-primary" class="mr-1">
                    Clone
                  </b-button>
                  <b-button size="sm" variant="outline-danger">
                    Clone
                  </b-button>
                </div>
              </b-media>
            </template>
          </b-table>
          <div class="mx-2 mb-2">
            <b-row>
              <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-start"
              >
                <span class="text-muted">
                  Showing 1-5 of 156 unassigned customers
                </span>
              </b-col>
              <!-- Pagination -->
              <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end"
              >
                <b-pagination
                  v-model="currentPage"
                  total-rows="1"
                  :per-page="10"
                  first-number
                  last-number
                  class="mb-0 mt-1 mt-sm-0"
                  prev-class="prev-item"
                  next-class="next-item"
                >
                  <template #first-text
                    ><span class="text-success">First</span></template
                  >
                  <template #prev-text>
                    <feather-icon icon="ChevronLeftIcon" size="18" />
                  </template>
                  <template #next-text>
                    <feather-icon icon="ChevronRightIcon" size="18" />
                  </template>
                  <template #last-text
                    ><span class="text-info">Last</span></template
                  >
                </b-pagination>
              </b-col>
            </b-row>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <b-row v-if="itemSelected">
      <b-col cols="12">
        <b-card border-variant="secondary">
          <div class="d-flex align-items-center justify-content-between">
            <h4 class="font-weight-bolder">Weekend Racing Push</h4>
            <div
              class="text-white bg-success d-flex rounded justify-content-center align-items-center font-weight-bolder"
              style="padding: 2px 4px; width: fit-content"
            >
              {{ itemSelected.status }}
            </div>
          </div>
          <p>
            <strong>Send Date:</strong> {{ itemSelected.sendDate }}
            <strong>at</strong> {{ itemSelected.sendTime }}
          </p>
          <p><strong>Recipients:</strong> {{ itemSelected.recipients }}</p>
          <p><strong>Target Group:</strong> {{ itemSelected.targetGroup }}</p>
          <p><strong>Message:</strong> {{ itemSelected.message }}</p>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Spinner from "@core/components/Spinner";
import {
  BButton,
  BCard,
  BCol,
  BPagination,
  BRow,
  BButtonGroup,
  BTable,
  BCardBody,
  BFormInput,
  BMedia,
  BLink,
  BAvatar,
} from "bootstrap-vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";

export default {
  components: {
    BButton,
    BCard,
    BRow,
    BCol,
    BTable,
    BMedia,
    BPagination,
    vSelect,
    Spinner,
    BButtonGroup,
    BTable,
    BCardBody,
    BFormInput,
    BAvatar,
    flatPickr,
    BLink,
  },
  data() {
    return {
      searchQuery: "",
      currentPage: 1,
      option: "Last 30 days",
      startDate: "",
      endDate: "",
      options: [
        { label: "Last 30 days", value: "last30days" },
        { label: "Last 7 days", value: "last7days" },
        { label: "Last 90 days", value: "last90days" },
      ],
      items: [
        {
          title: "Weekend Racing Push",
          status: "Sent",
          sentDate: "2025-06-14",
          sentTime: "10:00 AM",
          recipients: "8,200",
          targetGroup: "Racing Enthusiasts",
          message:
            "Get ready for the weekend races! Place your bets now and enjoy exclusive offers.",
        },
        {
          title: "NBA Playoffs Update",
          status: "Scheduled",
          sentDate: "2025-06-21",
          sentTime: "12:00 PM",
          recipients: "12,450",
          targetGroup: "Sports Fans",
          message:
            "NBA Playoffs start this weekend! Don't miss out on the action.",
        },
        {
          title: "Winter Welcome Push",
          status: "Draft",
          sentDate: "2025-06-25",
          sentTime: "09:30 AM",
          recipients: "10,000",
          targetGroup: "All Users",
          message: "Welcome to winter! Enjoy our latest promotions and offers.",
        },
      ],
      tableColumns: [
        { key: "title", label: "Title" },
        { key: "status", label: "Status" },
        { key: "sentDate", label: "Send Date" },
        { key: "recipients", label: "Recipients" },
        { key: "targetGroup", label: "Target Group" },
        { key: "actions", label: "Actions" },
      ],
      configDate: {
        // dateFormat: 'd-m-Y',
        altFormat: "d-m-Y",
        altInput: true,
        static: true,
      },
      itemSelected: null,
    };
  },
  computed: {},
  async mounted() {},
  methods: {
    onRowSelected(items) {
      this.itemSelected = items[0];
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
.table-hover-custom .table.table-hover tbody {
  tr {
    &.table-active {
      td {
        background-color: white !important;
        color: black !important;
      }
      &:hover {
        td {
          background-image: linear-gradient(white, white);
          background-repeat: no-repeat;
        }
      }
    }

    &:hover {
      background-color: #ececec !important;
      & > td {
        color: black !important;
      }
    }
  }
}
</style>
